import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { MultiItemCard } from '../../model/card';
import { MatIcon } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';

enum CardStatus {
  INIT = 'init',
  LOADING = 'loading',
  DEFAULT = 'default',
  CREATED = 'created',
  UPDATED = 'updated',
  DELETED = 'deleted',
  EDITING = 'editing',
  CANCELLED = 'cancelled',
  SAVED = 'saved',
  ERROR = 'error',
}

const ANIMATION_DURATION = 500;
const DELAY_RATE = 10;

@Component({
  selector: 'app-horizontal-card',
  templateUrl: 'horizontal-card.component.html',
  styleUrls: ['horizontal-card.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, MatIcon]
})
export class CardComponent implements OnChanges {


  @Input() card: MultiItemCard = null;

  @Output() onChange: EventEmitter<MultiItemCard> = new EventEmitter<MultiItemCard>();
  @Output() onDelete: EventEmitter<MultiItemCard> = new EventEmitter<MultiItemCard>();

  delay: number = 0;
  previewsValue: MultiItemCard = null;
  lastNotNullValue: MultiItemCard = null;
  status: CardStatus = CardStatus.INIT;

  beforeEditCard: MultiItemCard = null;


  constructor() { }


  ngOnChanges() {
    this.delay = Math.abs(DELAY_RATE);
    const isCardDeleted = this.card === null && this.previewsValue !== null;
    const isCardCreated = this.card !== null && this.previewsValue === null;
    const isCardUpdated = this.card !== null && this.previewsValue !== null;

    if (this.card !== null) {
      this.lastNotNullValue = this.card;
    } else if (this.previewsValue !== null) {
      this.lastNotNullValue = this.previewsValue;
    }

    if (isCardCreated) {
      this.performCreateAnimation();
    } else if (isCardDeleted) {
      this.performDeleteAnimation();
    } else if (isCardUpdated) {
      this.performUpdateAnimation();
    }
    this.previewsValue = this.card;
  }


  async onEditClick(): Promise<void> {
    this.beforeEditCard = JSON.parse(JSON.stringify(this.lastNotNullValue));
    this.status = CardStatus.EDITING;
  }

  async saveChanges(): Promise<void> {
    await this.performUpdateAnimation();
    this.onChange.emit(this.lastNotNullValue);
  }

  async cancelChanges(): Promise<void> {
    await this.performCancelAnimation();
    this.lastNotNullValue = this.beforeEditCard;
  }

  async onDeleteClick(): Promise<void> {
    this.onDelete.emit(this.lastNotNullValue);
  }

  async performCreateAnimation(): Promise<void> {

    await new Promise<void>((resolve) => {
      setTimeout(() => {
        this.status = CardStatus.CREATED;
        resolve();
      }, this.delay);
    });

    await new Promise<void>((resolve) => {
      setTimeout(() => {
        this.status = CardStatus.DEFAULT;
        resolve();
      }, ANIMATION_DURATION);
    });
  }

  async performDeleteAnimation(): Promise<void> {
    await new Promise<void>((resolve) => {
      setTimeout(() => {
        this.status = CardStatus.DELETED;
        resolve();
      }, this.delay);
    });

    await new Promise<void>((resolve) => {
      setTimeout(() => {
        this.status = CardStatus.INIT;
        resolve();
      }, ANIMATION_DURATION);
    });

  }

  async performUpdateAnimation(): Promise<void> {
    this.status = CardStatus.UPDATED;
    return new Promise((resolve) => {
      setTimeout(() => {
        this.status = CardStatus.DEFAULT;
        resolve();
      }, ANIMATION_DURATION);
    });
  }

  async performSaveAnimation(): Promise<void> {
    this.status = CardStatus.SAVED;
    return new Promise((resolve) => {
      setTimeout(() => {
        this.status = CardStatus.DEFAULT;
        resolve();
      }, ANIMATION_DURATION);
    });
  }

  async performCancelAnimation(): Promise<void> {
    this.status = CardStatus.CANCELLED;
    return new Promise((resolve) => {
      setTimeout(() => {
        this.status = CardStatus.DEFAULT;
        resolve();
      }, ANIMATION_DURATION);
    });
  }

  isStatus(s: string): boolean {
    return this.status === s;
  }

}
